import { useEffect, useState } from "react";
import { useAppSelector } from "src/common/state/hooks";
import { getCurrentUploadsStateList } from "src/features/gallery/state/gallerySlice";

const LAUNCHER_BOTTOM_PX = 79;
const UPLOAD_BAR_BOTTOM_PX = 139;
const LAUNCHER_ZONE_WIDTH_PX = 300;
const LAUNCHER_ZONE_HEIGHT_PX = 64;
const PAGINATION_GAP_PX = 8;

const computeLauncherBottom = (uploadBarVisible: boolean): number => {
  const base = uploadBarVisible ? UPLOAD_BAR_BOTTOM_PX : LAUNCHER_BOTTOM_PX;
  const pagination = document.getElementById("pagination-controls");
  if (!pagination) {
    return base;
  }
  const rect = pagination.getBoundingClientRect();
  const reachesLauncherZone =
    rect.width > 0 &&
    rect.right > window.innerWidth - LAUNCHER_ZONE_WIDTH_PX &&
    rect.bottom > window.innerHeight - base - LAUNCHER_ZONE_HEIGHT_PX;
  if (!reachesLauncherZone) {
    return base;
  }
  return Math.max(base, Math.ceil(window.innerHeight - rect.top) + PAGINATION_GAP_PX);
};

export const useHelpLauncherBottom = (): number => {
  const uploadBarVisible = useAppSelector(getCurrentUploadsStateList).length > 0;
  const [bottom, setBottom] = useState(() => computeLauncherBottom(uploadBarVisible));

  useEffect(() => {
    const apply = () => setBottom(computeLauncherBottom(uploadBarVisible));
    apply();
    const observer = new MutationObserver(apply);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, [uploadBarVisible]);

  return bottom;
};
